import { useSelector, useDispatch } from 'react-redux';
import FJImageToImageLeft from './FJImageToImageLeft';
import FJActionImageToImage from '../../../redux/action/FJActionImageToImage';
import { useCallback } from 'react';
import useLocalStore from '../../../hooks/useLocalStore';
import FJUtil from '../../../util/FJUtil';
import FJActionCommon from '../../../redux/action/FJActionCommon';

const FJImageToImageLeftContainer = () => {
    useLocalStore();

    const dispatch = useDispatch();
    const taskStatus = useSelector(state => state.common.taskStatus);
    const isProjectLoading = useSelector(state => state.common.isProjectLoading);
    const freeNumCreation = useSelector(state => state.common.freeNumCreation);
    const creditNumber = useSelector(state => state.common.creditNumber);
    const generateQuantity = useSelector(state => state.imageToImage.generateQuantity);

    const _onGenerate = useCallback(() => {
        if (FJUtil.isGeneratingStatus(taskStatus)) return;
        dispatch(FJActionImageToImage.generateAction());
        dispatch(FJActionCommon.setHeaderTabIndexAction(0));
    }, [dispatch, taskStatus]);

    return (
        <FJImageToImageLeft
            generateQuantity={generateQuantity}
            onGenerate={_onGenerate}
            taskStatus={taskStatus}
            freeNumCreation={freeNumCreation}
            creditNumber={creditNumber}
            isProjectLoading={isProjectLoading}
        />
    );
};
export default FJImageToImageLeftContainer;
